enum ThresholdType {
  SUMMER = 'SUMMER',
  WINTER = 'WINTER',
  ALL_SEASON = 'ALLSEASON',
  BRAKE_DISC = 'BRAKE_DISC',
}

export default ThresholdType;